import React from "react";
import { NavLink } from "react-router-dom";
import { canAccess, useAuth } from "../auth";
import { Icon, type IconName } from "../icons";
import { Avatar } from "../ui";
import { initials, titleCase } from "../format";
import { useQueueCounts } from "../useQueueCounts";
import type { ModuleKey } from "../types";

const NAV_ITEMS: { key: ModuleKey; label: string; path: string; icon: IconName }[] = [
  { key: "dashboard", label: "Dashboard", path: "/", icon: "grid" },
  { key: "reports", label: "Reports", path: "/reports", icon: "flag" },
  { key: "tickets", label: "Support Tickets", path: "/tickets", icon: "message-square" },
  { key: "notifications", label: "Notifications", path: "/notifications", icon: "bell" },
  { key: "listingApprovals", label: "Listing Approvals", path: "/listings", icon: "briefcase" },
  { key: "postContent", label: "Post Listing / Request", path: "/post", icon: "plus" },
  { key: "userVerification", label: "Users & Verification", path: "/users", icon: "user-check" },
  { key: "admins", label: "Admin Management", path: "/admins", icon: "users" },
];

export function Shell({ children }: { children: React.ReactNode }) {
  const { admin, signOutNow } = useAuth();
  const counts = useQueueCounts();

  return (
    <div className="shell">
      <aside className="sidebar">
        <div className="sidebar-brand">
          <img src="/logo.png" alt="" />
          <span>Roja Admin</span>
        </div>

        <nav className="col" style={{ gap: 2 }}>
          {NAV_ITEMS.filter((item) => canAccess(admin?.role ?? null, item.key)).map((item) => {
            const badge = counts[item.key];
            return (
              <NavLink key={item.path} to={item.path} end={item.path === "/"} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}>
                <Icon name={item.icon} />
                {item.label}
                {badge ? <span className="nav-badge">{badge}</span> : null}
              </NavLink>
            );
          })}
        </nav>

        <div className="sidebar-footer">
          <button className="nav-link" onClick={() => signOutNow()}>
            <Icon name="log-out" />
            Sign out
          </button>
        </div>
      </aside>

      <div className="main">
        <header className="topbar">
          <div className="grow" />
          <Avatar label={initials(admin?.name ?? "?")} />
          <div>
            <div className="t-body-strong">{admin?.name}</div>
            <div className="t-caption text-secondary">{titleCase(admin?.role ?? "")}</div>
          </div>
        </header>
        <main style={{ display: "flex", justifyContent: "center" }}>{children}</main>
      </div>
    </div>
  );
}
